import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PursesFacade } from './+state';
import { PursesStateModule } from './+state/purses.state.module';

import {
  PurseService
} from './services';

@NgModule({
  imports: [CommonModule, PursesStateModule],
})
export class DomainPursesModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainPursesModule,
      providers: [
        PurseService,
        PursesFacade
      ],
    };
  }
}
